import { ReactNode } from 'react';

const NewTabAnchor = ({ children, ...props }: { children?: ReactNode }) => (
  <a {...props} target="_blank" rel="noreferrer">
    {children}
  </a>
);

export default NewTabAnchor;
